import React from 'react';
import { Button } from '@crazyegginc/hatch';
import { useModal } from '/src/hooks';
import { Modal } from '/src/contexts/modal';

export function WrongPageWarningModal({ onConfirm, onCancel, resourceType = 'A/B Test', setupUrl }) {
  const modal = useModal();
  const isAbTest = resourceType === 'A/B Test';
  const actionWord = isAbTest ? 'test' : 'conversion';

  return (
    <Modal dialogClassName="!w-[360px]">
      <div className="flex flex-col items-start text-left">
        <h2 className="mb-5 text-xl text-black-pearl-500 leading-tight">
          This page doesn’t match your
          <br /> {resourceType}
        </h2>
        <div className="mb-5 flex flex-col items-start space-y-6 text-sm text-lynch-500">
          <div className="space-y-1">
            <p>This {actionWord} was created for:</p>
            <p className="break-all text-dodger-blue-500 font-normal">{setupUrl}</p>
          </div>
          <p>To continue, return to that page.</p>
        </div>
        <div className="flex items-center space-x-4">
          <Button
            className="px-10 py-2.5"
            onClick={() => {
              onConfirm?.();
              modal.close();
            }}
          >
            Open Page
          </Button>
          <Button
            variant="cancel"
            className="font-semibold"
            onClick={() => {
              onCancel?.();
              modal.close();
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
}
